query SupportRequest($id: ID!) {
  supportRequest(id: $id) {
    id
    number
    subject
    type
    status
    message
    details
    conversationId
    createdAt
    closedAt
    lastMessageAt
    waitingSince
    utm {
      source
      medium
      campaign
      content
      term
      link {
        id
        title
        deleted
      }
      email {
        kind
        automationId
        automationName
        nodeId
        template
      }
      capturedAt
      backfilled
    }
    user {
      id
      email
      displayName
      firstName
      lastName
    }
    platform {
      id
      title
    }
    assignee {
      id
      displayName
      email
    }
    payment {
      id
      status
      amount {
        value
        currency
      }
      product {
        id
        title
      }
    }
    assistantMessages {
      id
      role
      kind
      text
      createdAt
    }
    messages {
      id
      author
      channel
      body
      internal
      viaAssistant
      event
      fromEmail
      skippedAttachments
      hasOriginal
      createdAt
      staff {
        id
        displayName
        email
      }
      eventUser {
        id
        displayName
        email
      }
      attachments {
        name
        mimeType
        size
        url
      }
    }
  }
}
